import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "react-toastify";
import adminHttp from "../../../utils/adminHttp";


type Payload = {
  userId: string;

}

export const useDeleteAdminProvider = () => {
  const queryClient = useQueryClient();
  const { mutate, data, variables, ...rest } = useMutation({
    mutationKey: ['delete admin provider'],
    mutationFn: async ({ ...userId }: Payload) => {
      const response = await adminHttp.delete(
        `providers/provider?userId=${userId}`
      );
      return response.data;
    },

    onSuccess: () => {
      toast.success(
        `delete successfully`,
        { toastId: "customId" }
      );
      queryClient.invalidateQueries({
        queryKey: ["get admin provider list"] as const
      });
    },

    onError: (error) => {
      if (axios.isAxiosError(error)) {
        toast.error(
          error.response?.statusText || `Error deleting data`,
          { toastId: "customId" }
        );

      } else {
        toast.error(
          error?.message
          || "Error processing your request",
        );
      }
    },
  });

  return {
    deleteProvider: mutate,
    data,
    variables,
    ...rest,
  };
}